import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "../config/config.service";
import {BuscarNotaFiscal} from "../types/BuscarNotaFiscal.type";
import {NotaFiscalLiberarImportacao} from "../types/NotaFiscalLiberarImportacao.type";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BuscanotafiscalService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getNotaFiscal(instancia: string, nota: string, data: string){
    return this.httpClient.get<BuscarNotaFiscal[]>(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/buscar-nf?instancia=${instancia}&nota=${nota}&data=${data}`);
  }

  putAtualizaLiberaNotaFiscal(liberar: NotaFiscalLiberarImportacao){
    return this.httpClient.put(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/atualiza-libera-nf`, liberar);
  }

  exportar(corpo: any): Observable<any>{
    return this.httpClient.post(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/exportar-liberacao-nf`, corpo, { responseType: 'blob'});
  }
}
